import Events from '_utils/events';
import SampleService from '_services/rest/modules/sample';
import { _LOAD_MODEL_ } from './components/SampleModel';

export default {
  state: {
    sample: null,
    sampleList: null,
  },
  mutations: {
    setSample(state, response) {
      state.sample = response;
    },
    setSampleList(state, response) {
      state.sampleList = response;
    },
  },
  actions: {
    getSampleList({ commit }, params) {
      return SampleService.getList(params)
        .then(response => {
          commit('setSampleList', response);
        });
    },
    getSample({ commit }, params) {
      return SampleService.getSampleById(params)
        .then(response => {
          Events.$emit(_LOAD_MODEL_, response);
          commit('setSample', response);
        });
    },
    setSample({ commit }, params) {
      commit('setSample', params);
    },
  },
};
